<template>
<!--    <div class="">-->
<!--        <h1 class="asdf">{{$route}}</h1>-->
        <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
                <div id="printMe" v-if="attemp && user && test && certificatePassed === true" class="certificateContainer ">
                    <div class="certificateContainerDiploma">
                        <div class="borderDiploma">
                            <div class="certificate__row">
                                <h2 class="titleCourse">{{test.title}}</h2>
                            </div>
                            <div class=" textCert">
                                <div class="certificate__row max-1000">
                                    <h3 class="usernameCert">{{user.name}} {{user.surname}}</h3>
                                    <h4>{{date}}</h4>
                                    <p class="textCertfied">ONiAd Academy certifica que {{user.name}} {{user.surname}} ha superado con éxito esta certificación y acredita sus conocimientos en el campo de la publicidad programática.</p>
                                </div>
                                <div class="backgroundSkew"></div>
                            </div>
                            <div class="certificate__row">
                                <div class="" >
                                    <div class="" style="margin-bottom: 1em;">
                                        <img src="../assets/logo_oniad_academy/ONiAd-Academy-logotipo.png" alt="Logotipo ONiAd Academy" width="225px" class="figure-img img-fluid">
                                    </div>
                                    <div><p>Oniad Advertising SL como emisora del certificado</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="boxToShareContainer"  v-if="user">
                        <div class="boxToShare">
                            <div class="linkedin">
                                <social-sharing :url="ssnn.urlToShare" :title="ssnn.title" :description="ssnn.description" :hashtags="ssnn.hashtags" inline-template>
                                    <network network="linkedin">
                                        <img src="../assets/icons/linkedin.svg" alt="">
                                    </network>
                                </social-sharing>
                            </div>
                            <div class="twitter">
                                <social-sharing :url="ssnn.urlToShare" :title="ssnn.title" :description="ssnn.description" :hashtags="ssnn.hashtags" inline-template>
                                    <network network="twitter">
                                        <img src="../assets/icons/twitter.svg" alt="">
                                    </network>
                                </social-sharing>
                            </div>
                            <div class="whatsapp">
                                <social-sharing :url="ssnn.urlToShare" :title="ssnn.title" :description="ssnn.description" :hashtags="ssnn.hashtags" inline-template>
                                    <network network="whatsapp">
                                        <img src="../assets/icons/whatsapp.svg" alt="">
                                    </network>
                                </social-sharing>
                            </div>
                            <div class="print">
                                <img src="../assets/icons/pdf.svg" alt="" @click="print">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="certificatePassed === false" class="certificateContainer noPassed">
                    <h2>Lo sentimos pero no has superado con éxito el test</h2>
                    <p>Recibirás un email con un enlace para volver a intentarlo</p>
                    <p>Si quieres, puedes repasar el temario haciendo clic en el siguiente botón</p>
                    <router-link  tag="button" :to="{name: 'home'}" class="btn btn-success btn-lg">Ver temario</router-link>

                    <!--                    <div><pre>{{ attemp | pretty }}</pre></div>-->
                </div>

        </transition>

<!--    </div>-->
</template>

<script>
    /* eslint-disable */
    import Vue from 'vue'
    import {mapState} from 'vuex'
    import FloatLabel from "./elements/FloatLabel";
    import * as moment from 'moment';

    const SocialSharing = require('vue-social-sharing');
    Vue.use(SocialSharing);

    Vue.use(require('vue-moment'));

    const uuidv4 = require('uuid/v4');

    export default {
        name: 'certificate',
        filters: {
            pretty: function (value) {
                return value
                // return JSON.stringify(value, null, 2);
            }
        },
        components: {
            FloatLabel
        },
        computed: {
            date(){
                if (this.attemp){
                    return moment.utc(this.attemp.finished_at).locale(this.defaultLocale).local().format('LL');
                }
            },
            ...mapState(['attemp','user','test'])
        },
        data() {
            return {
                loading: false,
                defaultLocale: 'en',
                certificatePassed: null,
                ssnn:{
                    urlToShare: '',
                    title: 'Ya tengo el certificado en ONiAd',
                    description: 'He conseguido el certificado en publicidad programática en ONiAd, ¿Quieres verlo?',
                    hashtags: 'oniadMola'
                },
                // test: null
            }
        },
        mounted() {
            this.ssnn.urlToShare = window.url;
            this.defaultLocale = (window.navigator.language.includes('es') || window.navigator.language.includes('es-')) ? 'es' : 'en';
            if (window.navigator.language.includes('es') || window.navigator.language.includes('es-')){
                this.defaultLocale = 'es';
            }else if (window.navigator.language.includes('fr') || window.navigator.language.includes('fr')){
                this.defaultLocale = 'fr';
            }

            //get attemp
            this.getAttemp();
        },

        methods: {
            print(){
                window.print();
            },
            getAttemp: async function() {
                await this.$store.dispatch({
                    type: 'getCertificate',
                    data: {idTest: this.$route.params.idTest, idAttemp: this.$route.params.idAttemp}
                }).then((data) => {
                    this.$store.commit({type:'setAttemp',attemp:data});

                })
                    .then(()=>{
                        let title = document.title;
                        if (this.attemp.status === 'pass'){
                            console.log(title + ' aprobado')
                            document.title += ' aprobado';
                            this.$gtag.pageview({
                                page_title: document.title, // route name value
                                page_path: this.$route.path, // route path value
                                page_location: window.location.href
                            });
                            this.getUser();
                            this.getTest();
                            this.certificatePassed = true;
                        }else{
                            document.title += ' no aprobado';
                            this.$gtag.pageview({
                                page_title: document.title, // route name value
                                page_path: this.$route.path, // route path value
                                page_location: window.location.href
                            });
                            this.certificatePassed = false;
                        }
                    }).catch(()=>{this.$router.push({name:'home'})}).finally(()=>{this.loading = false;});
            },
            getUser: async function(){
                await this.$store.dispatch({
                    type: 'getUser',
                    id: this.attemp.user
                });
            },
            getTest: async function(){
                await this.$store.dispatch({
                    type: 'getTest',
                    data: {testId: this.attemp.test, user: this.attemp.user}
                });
            },

            beforeLeave(element) {
                this.prevHeight = getComputedStyle(element).height;
            },
            enter(element) {
                const {height} = getComputedStyle(element);

                element.style.height = this.prevHeight;

                setTimeout(() => {
                    element.style.height = height;
                });
            },
            afterEnter(element) {
                element.style.height = 'auto';
            },
        }
    }
</script>


<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Parisienne|Solway:400,500,700&display=swap');

    $main-color: rgba(50, 197, 210, 1);
    .mainContent{
        margin:0;
        padding: 0;
        width: 100%;
        max-width: 100%;
        background: #ccc;
    }
    .certificateContainer{
        display: flex;
        flex-direction: row;
        background: #ccc;
        width: 100%;
       justify-content: center;
        margin-top: -1em;
        .certificateContainerDiploma{
            max-width: 1400px;
            padding: 2em;
            margin: 2em;
            background: #fff;
            box-shadow: 0px 0px 15px #000;
            height: min-content;
            .borderDiploma{
                display: flex;
                flex-direction: column;
                justify-content: flex-start; /* center items vertically, in this case */
                align-items: center;
                align-content: center;
                border: 11px double #32c5d2;
                .certificate__row{
                    margin: 2em 0;
                    width: auto;
                    max-width: 900px;
                    padding: 0 2em;
                    text-align: center;
                    &.max-1000{
                        max-width: 1200px;
                    }
                }
            }
        }
        &.noPassed{
            justify-content: center;
            flex-direction: column;
            padding: 4em;
        }
        img{
            margin: 0 auto;
        }

        .titleCourse{
            font-size: 3rem;
        }
        .usernameCert{
            /*font-family: 'Parisienne', cursive;*/
            font-family: "Solway", serif;
            font-size: 4rem;
            text-decoration: underline;
            text-decoration-style: unset;
            text-decoration-thickness: 2px;
        }
        .textCert{
            position: relative;
            margin-top: 1rem;
            text-align: center;
            width: 100%;
            padding: 3rem 0;
            z-index: 999;
            .backgroundSkew{
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                background: #32c5d24a;
                transform: skew(0, -4deg);
                z-index: -1;

            }
        }
        .textCertfied{
            margin: 2em 0;
        }
        .certificate__header{
            background-color: $main-color;
            color: white;
            width: 100%;
            text-align: center;
            padding: 30px 0;
        }

        .certificate__footer{
            width: 100%;
            justify-self: flex-end;
            /*position: absolute;*/
            bottom: 0;
            >div{
                padding: 2em 0;
            }
        }
    }

    .boxToShareContainer{
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        left:0;
        bottom: 0;
        height: 130px;
        width: 100%;
        z-index: 999;
        .boxToShare{
            /*position: fixed;*/
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            z-index: 99;
            bottom:50px;
            right:50px;
            margin-right:50px;
            width: auto;
            max-width: 90%;
            background-color: #fff;
            padding: 1em;
            border-radius: 5px;
            box-shadow: 0 0 5px gray;
            img{
                width: 50px;
                min-width: 20px;
            }
            div{
                margin: 0 1em;
                cursor: pointer;
            }
        }
    }
    @media all and (max-width: 900px) {
        .certificateContainer .titleCourse{
            font-size: 2rem;
            font-weight: bold;
        }
        .textCert{
            .usernameCert{
                font-size: 2rem;
                font-weight: bold;
            }
            h6{
                font-size: 1.5rem;
            }
            .textCertfied{
                letter-spacing: 2px;
            }
        }
    }
    @media all and (max-width: 600px) {
        .certificateContainer .titleCourse{
            font-size: 1.5rem;
            font-weight: bold;
        }
        .textCert{
            .usernameCert{
                font-size: 2rem;
            }
            h6{
                font-size: 1.2rem;
            }
            .textCertfied{
                letter-spacing: 2px;
            }
        }
        .boxToShareContainer{
            justify-content: center;
            .boxToShare{
                margin: 0 10px;
            }
        }
    }
    @media all and (max-width: 500px) {
        .certificateContainer .titleCourse{
            font-size: 1.5rem;
            font-weight: bold;
        }
        .textCert{
            .usernameCert{
                font-weight: bold;
                font-size: 1.5rem;
            }
            h6{
                font-size: 1.2rem;
            }
            .textCertfied{
                letter-spacing: 2px;
            }
        }
    }
    @page {
        size: A4;

        margin: 0;
    }
    @media print {
        *{
            color-adjust: exact; -webkit-print-color-adjust: exact; print-color-adjust: exact;
        }
        body *{
            visibility: hidden;
        }
        .boxToShareContainer,.vue-back-to-top{
            visibility: hidden;
        }
        .textCert{
            /*background-color: rgba(50, 197, 210, 0.29) !important;*/
            /*-webkit-print-color-adjust: exact;*/
            .backgroundSkew{
                /*visibility: hidden;*/
                /*position: relative;*/
                background-color: rgba(50, 197, 210, 0.29) !important;
                color-adjust: exact;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        }
        .certificateContainer{

            .certificateContainerDiploma{
                visibility: visible;
                height: 100vh;
                margin: 0;
                box-shadow: none;
            }
            .certificateContainerDiploma *{
                visibility: visible;
            }
            .titleCourse{
                font-size: 2.5rem;
            }
            .usernameCert{
                font-size: 3rem;
            }
            .textCert{
                padding: 2rem 0;
            }
        }
    }
</style>
